import script from "./AppHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&id=1e45845a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e45845a"]])

export default __exports__